module.exports = __webpack_public_path__ + "img/Loa-for-consultation.c678780e.png";